import { message } from "antd";
import axios from "axios";

const url = `https://bodework-backend.herokuapp.com/api/`;
export const getAllData = async (endpoint) => {
  try {
    const result = await axios.get(`${url}${endpoint}`);
    return result?.data?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};

export const getDataById = async (endpoint, body) => {
  try {
    const result = await axios({
      method: "POST",
      url: url + endpoint,
      data: body,
      headers: {
        Accept: "application/json",
      },
    });
    return result?.data?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};

export const addOrUpdateData = async (
  endpoint,
  body,
  headers = { Accept: "application/json" }
) => {
  try {
    debugger;
    const result = await axios({
      method: "POST",
      url: url + endpoint,
      data: body,
      headers,
    });
    return result?.data?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};

export const deleteDataById = async (
  endpoint,
  body,
  headers = { Accept: "application/json" }
) => {
  try {
    const result = await axios({
      method: "POST",
      url: url + endpoint,
      data: body,
      headers,
    });
    return result?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};

export const addRemoveServiceFromFeatured = async (
  endpoint,
  body,
  headers = { Accept: "application/json" }
) => {
  try {
    const result = await axios({
      method: "POST",
      url: url + endpoint,
      data: body,
      headers,
    });
    return result?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};

export const login = async (endpoint, body, headers = { Accept: "application/json" }) => {
  try {
    const result = await axios({
      method: "POST",
      url: url + endpoint,
      data: body,
      headers,
    });
    return result?.data;
  } catch (error) {
    message.error(error.message);
    throw new Error(error?.message);
  }
};
